let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dObh5")).then(() => parcelRequire('ckQNN'));